module.exports = __webpack_public_path__ + "static/media/star.56ef2525.svg";